import { useTranslation } from "react-i18next";

import { Alert, Stack } from "@mui/material";

import { formatEuro } from "../../../../format/formatNumber";
import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { useBankruptcyChecklist } from "../../hooks/useBankruptcyChecklist";
import { CapabilityEmptyState } from "./components/capability-empty-state/CapabilityEmptyState";
import { CapabilityMetricCard } from "./components/capability-metric-card/CapabilityMetricCard";
import { CapabilityResult } from "./components/capability-result/CapabilityResult";

const TRANSLATION_BASE = "clients.client.debtSettlement.bankruptcyChecklist.bankruptcyCapability";

export function BankruptcyCapability() {
  const { t, i18n } = useTranslation();
  const { clientId } = useClientFileContext();
  const { data } = useBankruptcyChecklist(clientId);

  const capability = data?.bankruptcyCapability;

  return (
    <ClientContent>
      {!capability?.isAssetInventoryComplete ? (
        <CapabilityEmptyState />
      ) : (
        <Stack gap={2}>
          <Alert severity="info" sx={{ border: 1, borderColor: "info.light" }}>
            {t(`${TRANSLATION_BASE}.autoValuesNotice`)}
          </Alert>

          <Stack direction={{ xs: "column", md: "row" }} gap={2}>
            <CapabilityMetricCard
              caption={t(`${TRANSLATION_BASE}.fields.monthlyIncome`)}
              value={formatEuro(capability.monthlyIncome, i18n.language)}
              hint={t(`${TRANSLATION_BASE}.fields.fromAssetInventory`)}
            />
            <CapabilityMetricCard
              caption={t(`${TRANSLATION_BASE}.fields.monthlyExpenses`)}
              value={formatEuro(capability.monthlyExpenses, i18n.language)}
              hint={t(`${TRANSLATION_BASE}.fields.fromAssetInventory`)}
            />
            <CapabilityMetricCard
              caption={t(`${TRANSLATION_BASE}.fields.seizableAmount`)}
              value={formatEuro(capability.seizableAmount, i18n.language)}
              hint={t(`${TRANSLATION_BASE}.fields.seizableHint`, {
                count: capability.maintenanceObligationCount ?? 0,
              })}
            />
          </Stack>

          <CapabilityResult capability={capability} />
        </Stack>
      )}
    </ClientContent>
  );
}
